module.exports = __webpack_public_path__ + "59c923f628aa14b36247416ba25841cc.svg";


//////////////////
// WEBPACK FOOTER
// ./app/containers/Premium/images/navigators/ic-anchor-miniclass.svg
// module id = 1491
// module chunks = 3